export default "__VITE_ASSET__D$EPr96f__"